import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import type { CustomerGroupResource } from "@exonn/js-sdk";

export const module: Module<CustomerGroupResource> = {
  id: ResourceEnum.CustomerGroup,
  bigIcon: <i className="icon-20-customers_grp_adm" />,
  smallIcon: <i className="icon-15-customers_grp_adm" />,
  name: (t: TFunction) => t("moduleName.customerGroup"),

  tabs: {
    edit: {
      getTitle: (resource) => resource.title,
    },
  },
};
